// Callback.tsx — OAuth callback landing screen on react-bootstrap.
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

const Callback = () => {
    const [searchParams] = useSearchParams()
    const [error, setError] = useState('')

    useEffect(() => {
        const errorParam = searchParams.get('error')
        const token = searchParams.get('token')
        const returnTo = searchParams.get('return_to')

        if (errorParam) {
            setError(decodeURIComponent(errorParam))
            return
        }

        if (token) {
            localStorage.setItem('identity_token', token)
            const dest = returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')
                ? returnTo
                : '/dashboard'
            window.location.href = dest
            return
        }

        const code = searchParams.get('code')
        if (!code && !token && !errorParam) {
            window.location.href = '/login'
        }
    }, [searchParams])

    if (error) {
        return (
            <div className="auth-wrapper">
                <Card style={{ width: '420px', maxWidth: '100%' }} className="text-center">
                    <Card.Body>
                        <h2 className="mb-3">Authentication Error</h2>
                        <Alert variant="danger">{error}</Alert>
                        <Button
                            variant="primary"
                            onClick={() => { window.location.href = '/login' }}
                            className="w-100"
                        >
                            Back to Login
                        </Button>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    return (
        <div className="auth-wrapper">
            <Card style={{ width: '420px', maxWidth: '100%' }} className="text-center">
                <Card.Body>
                    <h2 className="mb-3">Authenticating…</h2>
                    <p className="text-muted m-0">Completing authentication…</p>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Callback
